<template>
  <div class="employee-list-item">
    <div class="row">
      <div class="col-3 col-sm-5 col-md-4 col-lg-4 col-xl-3">
        <employee-thumbnail :employee="employee"></employee-thumbnail>
      </div>
      <div class="col-7 col-sm-7 col-md-8 col-lg-8 col-xl-9">
          <h3>{{ employee.first_name }}</h3>
          <p>{{ employee.last_name_suffix }} {{ employee.last_name }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import EmployeeThumbnail from '@/components/Employee-Thumbnail'
export default {
  name: 'employee-list-item',
  props: ['employee'],
  components: {
    EmployeeThumbnail
  }
}
</script>

<style scoped>
  h3 {
    margin-top: 4px;
    margin-bottom: 0;
  }
  p {
    margin-bottom: 0;
  }
</style>